module.exports = __webpack_public_path__ + "img/scaeg1.png";